import { RectangleWithCustomRadius } from '../RectangleWithCustomRadius';
import {
  BAR_BOTTOM_RADIUS,
  BAR_TOP_LEFT_RADIUS,
  getTopRightRadius,
} from '../constants';
import { SegmentValue } from './SegmentValue';

interface SegmentRectangleProps {
  value: string;
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  isBottomRectangleInBar: boolean;
  isTopRectangleInBar: boolean;
  animateFromY: number;
  opacity?: number;
  disableAnimations?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const SegmentRectangle = ({
  value,
  x,
  y,
  width,
  height,
  color,
  isBottomRectangleInBar,
  isTopRectangleInBar,
  animateFromY,
  opacity = 1,
  disableAnimations = false,
  onMouseEnter,
  onMouseLeave,
}: SegmentRectangleProps) => {
  const topRightRadius = isTopRectangleInBar
    ? Math.min(getTopRightRadius(width), height)
    : 0;
  const topLeftRadius = isTopRectangleInBar ? BAR_TOP_LEFT_RADIUS : 0;
  const bottomRadius = isBottomRectangleInBar ? BAR_BOTTOM_RADIUS : 0;

  return (
    <g onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <RectangleWithCustomRadius
        background={{ color }}
        x={x}
        y={y}
        width={width}
        height={height}
        topRightRadius={topRightRadius}
        topLeftRadius={topLeftRadius}
        bottomLeftRadius={bottomRadius}
        bottomRightRadius={bottomRadius}
        animateFromY={animateFromY}
        opacity={opacity}
        disableAnimations={disableAnimations}
      />

      <SegmentValue
        segmentX={x}
        segmentY={y}
        animateFromY={animateFromY}
        segmentHeight={height}
        segmentWidth={width}
        text={value}
        segmentColor={color}
        disableAnimations={disableAnimations}
      />
    </g>
  );
};
